import axios from "axios";
import { BASE_URL } from "../../variables";

export const getDealerCityDRMApi = async (code) => {

    if (code) {
        const options = {
            url: `${BASE_URL}/services/apexrest/getDealerCityDRM/`,
            method: "post",
            data: {
                clusterCode: code,
            },
        };
        try {
            const response = await axios(options);

            if (response.status === 200) {
                return {
                    success: true,
                    data: response?.data?.accounts,
                };
            } else {
                throw Error("Something Went Wrong..!!");
            }
        } catch (err) {
            console.log(err);
            return {
                success: false,
                msg: "Somthing Went Wrong..!!",
            };
        }
    } else {
        return {
            success: true,
            data: { records: [] },
        };
    }
};
